import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useFood } from "./FoodLayout";
import PublicAcademicsPage from "@/components/PublicAcademicsPage";

export default function Academics() {
  const data = useFood();
  const docs = data.academics || [];
  return (
    <div data-testid="ft-ac-wrap">
      <PageHero eyebrow="Academic Resources" title="Academics" />
      <PageBody>
        <PublicAcademicsPage docs={docs} theme="orange" testidPrefix="ft-ac" />
      </PageBody>
    </div>
  );
}
